
























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class Modal extends Vue {
  @Prop({ type: Boolean, default: true }) protected closable!: boolean;
  @Prop({ type: Boolean, default: true }) protected wrapperClosable!: boolean;
  @Prop({ type: Boolean, default: true }) protected guttered!: boolean;
  @Prop({ type: String, default: null }) protected width!: string;
  @Prop({ type: String, default: null }) protected height!: string;

  private isOpen: boolean = false;

  get style() {
    if (this.width) {
      return 'width: ' + this.width + ';';
    }

    return '';
  }

  public open() {
    this.isOpen = true;
    this.$emit('onOpen');
  }

  public close() {
    this.isOpen = false;
    this.$emit('onClose');
  }

  private wrapperClose() {
    return this.wrapperClosable && this.closable && this.close();
  }
}
